import { isImage } from 'src/helpers/CommonHelpers';
import { ServiceRequestDocument } from 'src/SharedCustomHooks/UseNotesAPI/types';

export interface DocumentAttachmentPreview {
  hasAttachment: boolean;
  firstCompressedAttachment?: string;
  totalAttachments: number;
}

export interface EnrichedServiceRequestDocument extends ServiceRequestDocument {
  attachmentPreview: DocumentAttachmentPreview | null;
}

export const buildDocumentAttachmentPreview = (
  doc: ServiceRequestDocument
): DocumentAttachmentPreview | null => {
  const imageUrl: string = doc.image ?? doc.document ?? null;

  if (!imageUrl || !isImage(imageUrl)) {
    return null;
  }

  return {
    hasAttachment: true,
    firstCompressedAttachment: imageUrl,
    totalAttachments: 1,
  };
};
